import React, { useState, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';

// Components

import SectionHeading from '../SectionHeading/SectionHeading';

// Utilities

import { truncateString, setNestedFieldName, setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

export default function FileInput(props) {
    const [showHelpText, setShowHelpText] = useState(false);
    const {
        formik,
        fieldName,
        label,
        helpText,
        isRequired,
    } = props;

    const fileUpload = useRef(null);
    const selectedFile = fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName];
    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    const confirmAddFile = (selected) => {
        if (selected) {
            if (window.confirm("Ya existe un archivo anexo, ¿desea sustituirlo?")) {
                fileUpload.current.click()
            }
        } else {
            fileUpload.current.click()
        }
    }

    return (
        <div className="file-field">
            {label &&
            <SectionHeading text={<>{label} {isRequired && <span>*</span>}</>} isSubHeading />}

            <button
                type="button"
                className={touched && error ? "file-input-button input-error" : "file-input-button"}
                onClick={() => confirmAddFile(selectedFile)}
            >
                <FontAwesomeIcon icon={faPaperclip} /> {selectedFile ? truncateString(selectedFile.name, 30) : 'Seleccionar archivo'}
            </button>

            {helpText &&
            <button type="button" className='file-input-help-button' onClick={() => setShowHelpText(!showHelpText)}>
                <FontAwesomeIcon icon={faCircleQuestion} />
            </button>}

            <input
                ref={fileUpload}
                className="file-input"
                id={fieldName}
                name={fieldName}
                type="file"
                accept={"image/x-png,image/jpeg,image/jpg,.pdf"}
                onChange={(event) => { formik.setFieldValue(fieldName, event.currentTarget.files[0]) }}
                onBlur={formik.handleBlur(fieldName)}
                required={isRequired}
            />

            {showHelpText &&
            <p><small className="p-helptext">{helpText}</small></p>}

            <span className='p-error'>{error}</span>

        </div>
    )
}
